<template>
  <div>
    <v-row>
      <v-col cols="12">
        <px-autocomplete-fornecedor-grupo-compra
          outlined
          hide-details
          class="required"
          autocomplete="off"
          label="Grupo de compra"
          :error="$v.catalogo.gruposCompras.$error"
          @blur="$v.catalogo.gruposCompras.$touch()"
          v-model="catalogo.gruposCompras"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          outlined
          hide-details
          class="required"
          autocomplete="off"
          label="Nome do catálogo"
          maxlength="100"
          :error="$v.catalogo.nome.$error"
          @blur="$v.catalogo.nome.$touch()"
          v-model="catalogo.nome"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <px-autocomplete-users
          outlined
          hide-details
          label="Usuários responsáveis"
          autocomplete="off"
          v-model="catalogo.users"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-switch
          hide-details
          v-model="catalogo.ativo"
          label="Catálogo ativo"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col cols="12">
        <v-btn color="primary"
               @click="emitNext">
          Próximo
        </v-btn>
        <v-btn class="ml-2" text @click="emitCancel">Cancelar</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    catalogo: Object,
  },
  data() {
    return {};
  },
  methods: {
    emitNext() {
      if (this.validateForm()) {
        return;
      }
      this.$emit('next');
    },
    emitCancel() {
      this.$emit('cancel');
    },
  },
  created() {},
  validations: {
    catalogo: {
      gruposCompras: {
        required,
      },
      nome: {
        required,
      },
      fornecedor: {
        required,
      },
    },
  },
};
</script>
